import React, { useState, useEffect } from 'react';
import { motion, useScroll, useSpring } from "framer-motion";
import { utils } from "../../utils";
import { FormInput, MainNavbar, SubFooter } from "../../components";
import { useDispatch } from "react-redux";
import { setPaymentCardData, setSavedCards } from "../../includes/navSlice";
import { useNavigate } from 'react-router-dom';
import { Space, message, Alert } from "antd";


const formlabel = "#a0a0a0";
const inputlabel = "#257a80";

const AddCard = () => 
{	
	const { scrollYProgress } = useScroll();
	const scaleX = useSpring(scrollYProgress, {
		stiffness: 100,
		damping: 30,
		restDelta: 0.001
	});
	
	const dispatch = useDispatch();
	const sessionemail = utils.getStorage('__el_data_email');
    const authToken = utils.getStorage('__el_data_login_token');
    const navigate = useNavigate();
	
	
	const [cardNo, setCardNo] = useState('');
	const [cardName, setCardName] = useState('');
	const [cardExp, setCardExp] = useState('');
	const [cardCvv, setCardCvv] = useState('');
	const [cardZip, setCardZip] = useState('');
	const [visible, setVisible] = useState(false);	
	const [msgType, setMsgType] = useState('');	
	const [msgBody, setMsgBody] = useState('');	
	const [msgHead, setMsgHead] = useState('');	
	
	const [os, setOs] = useState('');
	const [model, setModel] = useState('');
	
	
	useEffect(() => 
	{	
		setOs('');
		setModel('');
	},[]);
	
	const SwitchRef = (ref) => {
		navigate(ref);
	}
	
	const onAddCard = async () => 
	{
		try{
			if(cardCvv && cardName && cardZip && cardNo && cardExp){}else{
				setVisible(true);
				setMsgHead('');
				setMsgBody('Please check all required fields');
				setMsgType('error');
				window.scrollTo({top: 0, behavior: 'smooth'});
				return;
			}
			const target = utils.USER_URL;
			const header = new Headers({
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': 'Bearer '+authToken,
			});
			const posturl = utils.BASE_URL+target; //utils.POST_URL;
			const localtime = await utils.getTime();
			const obj = JSON.stringify({'rtype': 'addcard', 'email': sessionemail, 'cardno': cardNo, 'cardname': cardName, 'cardzip': cardZip, 'cardexp': cardExp, 'cardcvv': cardCvv, 'remember': true, 'os': os, 'model': model, 'localtime': localtime, 'target': target, 'token': authToken, '_c': 'w'});
			const dataToPost = await utils.cipherEncode(obj);			
			const res = await utils.fetchURL(posturl, 'POST', dataToPost, header);
			const data = await res.json();
			
			if(data.msg === 'Success'){
				if(data?.paymentcard){
					await dispatch(setPaymentCardData(utils.cipherDecode(data.paymentcard)));
					await dispatch(setSavedCards(JSON.stringify(utils.cipherDecode(data.paymentcard))));
				}
				setVisible(true);
				setMsgHead('');				
				setMsgBody('Card was successfully added');
				setMsgType('success');
				window.scrollTo({top: 0, behavior: 'smooth'});			
			}else{
				setVisible(true);
				setMsgHead('');
				setMsgBody(data.msg);
				setMsgType('error');
				window.scrollTo({top: 0, behavior: 'smooth'});
			}
			
		}catch(e){
			message.error(e.message);
		}		
	}

	function handleClose(){
		setVisible(false);
	}

    function renderForm() {
        return (
		<>
			<motion.div className="pprogress-bar" style={{ scaleX }} />			
			<div className="el-global--wrapper">
				<div className="el-entry el-page--transition">
					<MainNavbar />
					<div className="el-preview container slide-in-bottom" id="el-dashboard-container">
						<div className="sc-lhlUkk kRzDDN">
							<div className="animated margin-bottom-4 flex justify-between mx-auto align-center c-box-width">
								<div className="cus_title_wrap">
									<h2>{`Add Payment Card`}</h2>
								</div>
								<div className="">
									
								</div>
							</div>
							<Space className="alertbutton" direction="vertical">
								{visible && (<Alert				
									message={msgHead}
									description={msgBody}
									type={msgType}
									closable 
									afterClose={handleClose}				
								/>)}
							</Space>
							<div className="sc-cabOPr kUdOjq login-card--wrap auth-wrap elAnimated elFadeInUp text-center el-overflow--hidden slide-in-bottom c-box-width c-box">
								<div className="cus_back_button_wrap" style={{margin: "0px 0px"}}>
									<button type="solid" style={{display: "flow-root", marginBottom: 30}} className="cus_back_button" onClick={()=> SwitchRef('/payments')}>Back</button>
								</div>
		
            <div                
				style={{
                    backgroundColor: '#f7f7f7',
					background: "rgb(255, 255, 255) none repeat scroll 0% 0%",
					boxShadow: "rgba(0, 0, 0, 0.06) 0px 0px 25px",
					borderRadius: 4,
					padding: "32px 23px",
					margin: "32px 0px",
                }}
            >
					
				<div
					style={{
						marginBottom: 5,
					}}
				>
				
				</div>
		
			{/* Address Label */}
				<FormInput
					label="Card Number *"
					placeholder="9999 9999 9999 9999"
					secureTextEntry="text"
					inputType="inputmask"
					inputId="cardNo"
					mask="9999 9999 9999 9999"
					onChange={(e) => setCardNo(e.target.value)}
					value={cardNo}
					containerStyle={{
						marginTop: 15,
						width: '100%',
						textAlign: 'left',
					}}
					inputContainerStyle={{
						backgroundColor: '#ffffff',
						width: '100%'
					}}
					inputLabelStyle={{
						color: formlabel,
					}}
					inputClass={'cus_input'}
					inputStyle={{color: inputlabel}}
				/>
			
			
			
			{/* Address Label */}
				<FormInput
					label="Cardholder Name *"
					placeholder="Cardholder Name"
					secureTextEntry="text"
					inputType="input"
					inputId="cardName"
					onChange={(e) => setCardName(e.target.value)}
					value={cardName}
					containerStyle={{
						marginTop: 15,
						width: '100%',
						textAlign: 'left',
					}}
					inputContainerStyle={{
						backgroundColor: '#ffffff',
						width: '100%'
					}}
					inputLabelStyle={{
						color: formlabel,
					}}
					inputClass={'cus_input'}
					inputStyle={{color: inputlabel}}
				/>
				
				
				{/* Address Label */}
				<FormInput
					label="Expiry Date [MM/YY]*"
					placeholder="MM/YY"
					secureTextEntry="text"
					inputType="inputmask"
					inputId="cardExp"
					mask="99/99"
					onChange={(e) => setCardExp(e.target.value)}
					value={cardExp}
					containerStyle={{
						marginTop: 15,
						width: '100%',
						textAlign: 'left',
					}}
					inputContainerStyle={{
						backgroundColor: '#ffffff',
						width: '100%'
					}}
					inputLabelStyle={{
						color: formlabel,
					}}
					inputClass={'cus_input'}
					inputStyle={{color: inputlabel}}
				/>
			
			{/* Address Label */}
				<FormInput
					label="CVV *"
					placeholder="CVV"
					secureTextEntry="text"
					inputType="input"
					inputId="cardCvv"
					onChange={(e) => setCardCvv(e.target.value)}
					value={cardCvv}
					maxLength={3}
					containerStyle={{
						marginTop: 15,
						width: '100%',
						textAlign: 'left',
					}}
					inputContainerStyle={{
						backgroundColor: '#ffffff',
						width: '100%'
					}}
					inputLabelStyle={{
						color: formlabel,
					}}
					inputClass={'cus_input'}
					inputStyle={{color: inputlabel}}
				/>
			
			{/* Address Label */}
				<FormInput
					label="Zip/Postal Code *"
					placeholder="Zip"
					secureTextEntry="text"
					inputType="input"
					inputId="cardZip"
					onChange={(e) => setCardZip(e.target.value)}
					value={cardZip}
					maxLength={10}
					containerStyle={{
						marginTop: 15,
						width: '100%',
						textAlign: 'left',
					}}
					inputContainerStyle={{
						backgroundColor: '#ffffff',
						width: '100%'
					}}
					inputLabelStyle={{
						color: formlabel,
					}}
					inputClass={'cus_input'}
					inputStyle={{color: inputlabel}}
				/>
			
				{/* Button */}
				<FormInput
					label="Submit"
					secureTextEntry="text"
					inputType="button"
					inputId="button1"
					onClick={()=> onAddCard()}
					containerStyle={{
						marginTop: 5,
						marginBottom: 25,
						width: '100%'
					}}
					inputClass={'cus_button'}
					inputStyle={{}}
				/>
			
			
			
            </div>
									
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<SubFooter />
		</>
        )
    }
	
	return (
		
		<div 
			style={{}}
		>
			{renderForm()}
		</div>
		
	)
};


export default AddCard;